import React from 'react';
import { MdMenu, MdChevronRight, MdNotifications, MdClose } from "react-icons/md";

const Header = ({
  isMobile,
  isTablet,
  toggleSidebar,
  activeMenu,
  notificationRef,
  notificationsVisible,
  setNotificationsVisible,
  getNotificationCount,
  getNotificationTitle,
  renderNotifications
}) => {
  return (
    <div className="flex items-center justify-between mb-8 glass-header p-5 rounded-3xl animate-fade-in border border-white/40">
      <div className="flex items-center space-x-6">
        {(isMobile || isTablet) && (
          <button onClick={toggleSidebar} className="p-3 bg-white hover:bg-teal-600 hover:text-white rounded-2xl transition-all shadow-sm border border-slate-100">
            <MdMenu className="w-6 h-6" />
          </button>
        )}
        <div>
          <div className="flex items-center space-x-2 text-[10px] font-extrabold text-slate-400 uppercase tracking-[0.2em] mb-1 px-0.5">
            <span className="hover:text-teal-600 cursor-pointer transition-colors">Workspace</span>
            <MdChevronRight className="w-3.5 h-3.5" />
            <span className="text-teal-700 font-black">{activeMenu}</span>
          </div>
          <h2 className="text-2xl font-extrabold text-slate-900 tracking-tight">{activeMenu}</h2>
        </div>
      </div>

      <div className="flex items-center space-x-4">
        <div className="relative" ref={notificationRef}>
          <button
            onClick={() => setNotificationsVisible(prev => !prev)}
            className="h-[52px] w-[52px] flex items-center justify-center bg-white border border-slate-100 rounded-2xl hover:border-teal-500 hover:shadow-lg hover:shadow-teal-100 transition-all text-slate-400 hover:text-teal-600 relative group"
          >
            <MdNotifications className="w-6 h-6" />
            {getNotificationCount() > 0 && (
              <span className="absolute top-3 right-3 w-3 h-3 bg-red-500 border-2 border-white rounded-full" />
            )}
          </button>
          {notificationsVisible && (
            <div className="absolute top-[calc(100%+14px)] right-0 glass-panel rounded-3xl shadow-2xl z-[100] overflow-hidden w-[320px] sm:w-[380px] border border-slate-100 animate-fade-in origin-top-right">
              <div className="p-5 border-b border-slate-100 flex justify-between items-center bg-slate-50/50">
                <h3 className="font-black text-slate-800 text-[10px] uppercase tracking-[0.2em]">{getNotificationTitle()}</h3>
                <button 
                  onClick={() => setNotificationsVisible(false)} 
                  className="p-1.5 hover:bg-red-50 text-slate-400 hover:text-red-500 rounded-lg transition-colors"
                >
                  <MdClose className="w-5 h-5" />
                </button>
              </div>
              <div className="p-4 max-h-[450px] overflow-y-auto custom-scrollbar">{renderNotifications()}</div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Header;
